<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer4">
      <b-row>
        <b-col class="col-12">
            <label class="font-weight-bolder">Paying your plan premium</label>
            <span v-html="form.PayerPaymentText" v-if="form.PayerPaymentText"></span>
          <span v-if="!form.PayerPaymentText">
            <br />
          <b>If enrolling in {{form.PayerName}} Advantage 001 and 003 with a $0 monthly premium: If we determine that you
          owe a late enrollment penalty (or if you currently have a late enrollment penalty), we need to know how
            you would prefer to pay it.</b> You can pay by mail. You can also choose to pay your premium by automatic
          deduction from your Social Security or Railroad Retirement Board (RRB) benefit check each month. If you
          are assessed a Part D-Income related Monthly Adjustment Amount, you will be notified by the Social
          Security Administration. You will be responsible for paying this extra amount in addition to your plan
          premium. You will either have the amount withheld from your Social Security benefit check or be billed
          directly by Medicare or the RRB. <b>DO NOT pay {{this.form.PayerName}} the Part D-IRMAA.</b>
          <br><br>
          <b>If enrolling in {{form.PayerName}} Value 002 and 004 with a monthly premium: You can pay your monthly plan
            premium including any late enrollment penalty that you currently have or may owe by mail. You can also
            choose to pay your premium by automatic deduction from your Social Security or Railroad Retirement
            Board (RRB) benefit check each month.</b>
          <br><br>
          <b>If you are assessed a Part D-Income Related Monthly Adjustment Amount, you will be notified by the Social
          Security Administration. You will be responsible for paying this extra amount in addition to your plan
          premium. You will either have the amount withheld from your Social Security benefit check or be billed
            directly by Medicare or RRB. DO NOT pay {{this.form.PayerName}} the Part D-IRMAA.</b>
          <br><br>
          If you don’t select a payment option, you will receive a bill quarterly.
            <!--          <hr />-->
          <br>
          </span>
          <b>
            <label>Please select a premium payment option</label>
          </b>
          <validation-provider
            :bails="false"
            v-slot="{ classes, errors }"
            name="Payemtn Options "
            class="col-3 p-0 mr-1"
            vid="paymentoption"
          >
            <div>
              <b-form-radio-group
                v-model="form.paymentinterval"
                id="paymentinterval"
                class="pt-2"
                :options="[{text:'Get a bill quarterly',value:'1'},{text:'Automatic deduction from your monthly Social Security or Railroad Retirement Board (RRB) benefit check', value:'2'}]"
                stacked
                ref="paymentoption"
              ></b-form-radio-group>
              <div class="control" :class="classes">
                <span>{{errors[0]?"Please select one of the payment options.":""}}</span>
              </div>
            </div>
          </validation-provider>
          <br />
          <p>(The Social Security/RRB deduction may take two or more months to begin after Social Security or RRB approves the deduction. In most cases, if Social Security or RRB accepts your request for automatic deduction, the first deduction from your Social Security or RRB benefit check will include all premiums due from your enrollment effective date up to the point withholding begins. If Social Security or RRB does not approve your request for automatic deduction, we will send you a paper bill for your monthly premiums.)</p>
        </b-col>
      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";

export default {
  name: "PaymentOptionInfoComponent",
  components: {},
  data() {
    return {};
  },
  props: {
    form: Object
  }
};
</script>
